import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import { loginService, userService, vipService } from '@vip-activity/business';
import util from '@tencent/vft-common/util';
import { buildUrl } from '@tencent/vft-common/url';
import { defaultAvatar } from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { removeHttp } from '@vip-activity/base';
import { shieldRun } from '@vip-activity/utils';
import params from '../config';
Vue.mixin({
  data: function data() {
    return _objectSpread(_objectSpread({}, params), {}, {
      loginService: loginService,
      userService: userService,
      vipService: vipService,
      defaultAvatar: defaultAvatar,
      accountCheck: accountCheck
    });
  },
  filters: {
    removeHttp: removeHttp,
    hideNick: util.hideNick,
    formatNum: util.formatNum
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['isLiveEnd', 'isLive', 'starList', 'myPropsNum'])), mapState(['currentPkg', 'hasTicket', 'orderList', 'now'])), {}, {
    isSelf: function isSelf() {
      if (!this.loginService.isLogin) return false;
      return +this.uid === +this.userService.vuid;
    },
    userAvatar: function userAvatar() {
      return this.userService && this.userService.headurl || defaultAvatar;
    },
    isPropsEnd: function isPropsEnd() {
      var endTime = window.setting.道具配置.截榜时间;
      return new Date(this.now) > new Date(endTime);
    }
  }),
  methods: {
    hideNick: function hideNick() {
      return util.hideNick.apply(util, arguments);
    },
    openPay: function openPay() {
      var checkTicket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.loginService.isLogin) {
        this.loginService.openLogin();
        return;
      }

      if (!checkTicket) {
        this.eventBus.$emit('showPayPop');
        return;
      }

      if (!this.hasTicket) {
        this.eventBus.$emit('showPayPop');
      }
    },
    shieldRun: shieldRun,
    $openLogin: function $openLogin() {
      this.loginService.openLogin();
    },
    loginTips: function loginTips() {
      var _this = this;

      this.confirm({
        msg: '当前登录态已过期，请重新登录',
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _this.$openLogin();
        }
      });
    },
    isSchema: function isSchema() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return url.match(/^(txvideo|tenvideo2)/);
    },
    openUrl: function openUrl(url) {
      if (!url) {
        return;
      }

      if (this.isSchema(url)) {
        accountCheck.openApp(url);
      } else if (env.isApp) {
        var subUrl = url.indexOf('//') === 0 ? window.location.protocol + url : url;
        atom.invoke('openView', {
          url: "txvideo://v.qq.com/HollywoodH5Activity?url=".concat(encodeURIComponent(subUrl))
        });
      } else {
        window.location.href = url;
      }
    },
    openProperty: function openProperty() {
      this.openUrl('//film.qq.com/weixin/v3/asset/index.html?header=0#award');
    },
    openVip: function openVip() {
      var isUpgrade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.loginService.isLogin) {
        this.$openLogin();
        return;
      }

      var isTv = !!util.getUrlParam('fromtv');
      var _window$setting$$ = window.setting.支付面板.引导文案,
          SVIP开通链接 = _window$setting$$.SVIP开通链接,
          会员开通链接 = _window$setting$$.会员开通链接;
      var curUrl = window.location.href;
      var url = buildUrl(isTv ? SVIP开通链接 : 会员开通链接, {
        ru: encodeURIComponent(curUrl)
      });
      var oldPtag = util.getUrlParam('ptag', url);
      url = util.setUrlParam('ptag', "".concat(isUpgrade ? 'upgrade' : 'buy', ".").concat(oldPtag), url);
      this.openUrl(url);
    },
    openKefu: function openKefu() {
      this.openUrl('//kf.qq.com/touch/video/index.html');
    },
    launchPropsShare: function launchPropsShare(_ref) {
      var starid = _ref.starid,
          propsCount = _ref.propsCount;
      var allCount = null;
      var _this$$store$state = this.$store.state,
          voteInfo = _this$$store$state.voteInfo,
          supportList = _this$$store$state.supportList;

      if (starid === 'all') {
        var _this$$store$getters$, _voteInfo$all;

        starid = (_this$$store$getters$ = this.$store.getters.theMostLikeStar) === null || _this$$store$getters$ === void 0 ? void 0 : _this$$store$getters$.id;
        allCount = (_voteInfo$all = voteInfo.all) === null || _voteInfo$all === void 0 ? void 0 : _voteInfo$all.popularity;
      }

      var item = this.starList.find(function (star) {
        return star.id === starid;
      });
      var star = voteInfo[starid] || supportList.find(function (star) {
        return star.id === starid;
      });
      var params = {
        starid: starid,
        allCount: allCount,
        propsCount: allCount || propsCount || (star === null || star === void 0 ? void 0 : star.popularity)
      };

      if (item) {
        params.starSrc = item.分享背景图;
        params.starName = item.明星剧名;
      }

      this.eventBus.$emit('launchPropsShare', params);
      console.log('launchPropsShare', starid, params);
    },
    giveProps: function giveProps(id) {
      var myPropsNum = this.$store.getters.myPropsNum;

      if (myPropsNum) {
        this.eventBus.$emit('showPowerPop', {
          id: id
        });
      } else {
        // todo 拉起支付
        this.eventBus.$emit('showPayPop', {
          id: id
        });
      }
    }
  }
});